<template>
  <div>

    <h2>{{ $t('title.user-levels') }}</h2>

    <base-list
      model="user-levels"
      :columns="['name']"
      s-model="user-level"
      />

  </div>
</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'user-level-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// UserLevelList.vue?2b048020